export const enumAlerts = Object.freeze({
  ALL: "ALL",
  NOVO_PEDIDO: "NOVO_PEDIDO",
  PEDIDO_IRREGULAR: "PEDIDO_IRREGULAR",
  NF_NAO_GERADA: "NF_NAO_GERADA",
  PIX_PAGO_TERCEIRO: "PIX_PAGO_TERCEIRO",
  NF_ANTECIPADA_SEM_PAGAMENTO: "NF_ANTECIPADA_SEM_PAGAMENTO",
  LIBERACAO_ANTECIPADA: "LIBERACAO_ANTECIPADA",
  ERRO_PAGAMENTO: "ERRO_PAGAMENTO",
  PREVENCAO_CHARGEBACK: "PREVENCAO_CHARGEBACK",
  TETO_TRADUCAO_ATINGIDO: "TETO_TRADUCAO_ATINGIDO",
});

export const mapAlerts = {
  [enumAlerts.ALL]: {
    label: "Todas",
    color: "bg-exitos text-white",
  },
  [enumAlerts.NOVO_PEDIDO]: {
    label: "Novo pedido",
    color: "bg-green text-white",
  },
  [enumAlerts.PEDIDO_IRREGULAR]: {
    label: "Pedido irregular",
    color: "bg-orange text-white",
  },
  [enumAlerts.NF_NAO_GERADA]: {
    label: "NF não gerada",
    color: "bg-yellow text-dark",
  },
  [enumAlerts.PIX_PAGO_TERCEIRO]: {
    label: "Pix pago por terceiro",
    color: "bg-primary text-white",
  },
  [enumAlerts.NF_ANTECIPADA_SEM_PAGAMENTO]: {
    label: "NF vencida",
    color: "bg-orange text-white",
  },
  [enumAlerts.LIBERACAO_ANTECIPADA]: {
    label: "Liberação Antecipada",
    color: "bg-warning text-white",
  },
  [enumAlerts.ERRO_PAGAMENTO]: {
    label: "Erro de pagamento",
    color: "bg-danger text-white",
  },
  [enumAlerts.PREVENCAO_CHARGEBACK]: {
    label: "Prevenção de chargeback",
    color: "bg-purple text-white",
  },
  [enumAlerts.TETO_TRADUCAO_ATINGIDO]: {
    label: "Teto de tradução",
    color: "bg-info text-white",
  },
};

export const alertFilterKeys = Object.freeze([
  enumAlerts.ALL,
  enumAlerts.NOVO_PEDIDO,
  enumAlerts.PEDIDO_IRREGULAR,
  enumAlerts.NF_NAO_GERADA,
  enumAlerts.PIX_PAGO_TERCEIRO,
  enumAlerts.NF_ANTECIPADA_SEM_PAGAMENTO,
  enumAlerts.LIBERACAO_ANTECIPADA,
  enumAlerts.ERRO_PAGAMENTO,
  enumAlerts.PREVENCAO_CHARGEBACK,
]);

export function getPropByKey(key, prop) {
  if (!Reflect.has(mapAlerts, key)) return "";
  if (!Reflect.has(mapAlerts[key], prop)) return "";

  return Reflect.get(mapAlerts[key], prop);
}

export const mapLabels = Object.fromEntries(
  Object.keys(mapAlerts)
    .filter((key) => key !== enumAlerts.ALL)
    .map((key) => [key, getPropByKey(key, "label")])
);
